module.exports = __webpack_public_path__ + "src/img/up.538176ae.svg";